import axios from "axios";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_HEALTH_URL = process.env.VUE_APP_API_URL + "/health";

export default class HealthController {
  static async fetchHealth() {
    const response = await axios.get(API_HEALTH_URL);
    return response.data;
  }
}

applyErrorHandlers(HealthController);
